module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sts-header'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('sts-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1de76b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Shell.vue
// module id = 298
// module chunks = 1